export const _apiServer = "https://cms.houseofyards.com";
export const _api_host = "https://api.staging.houseofyards.com";
export const _bam_host = "https://bam.staging.houseofyards.com/#";
export const _bpm_host = "https://hoy.demo.houseofyards.com";
export const _bpm_domain = "demo.houseofyards.com";